import SectionTitle from "components/section-title/SectionTitle";

const GoalsSections: React.FC = () => {
  return (
    <div>
      <SectionTitle>Goals</SectionTitle>

      <p>
        From experience, I thrive more in small-size companies. I wish to have
        responsibility and freedom to build impactful and meaningful projects. I
        am looking to join a start-up and be part of an adventure along side a
        united and ambitious team.
        <br />
        <br />
        At the moment, I am a front-end web developer but I am aiming to be full
        stack by continuously honing my craft building challenging projects. Do
        more is my motto.
      </p>
    </div>
  );
};

export default GoalsSections;
